import React, { Fragment } from 'react';
import Footer from '../../component/Other/Footer';
import Navbar from '../../component/Other/Navbar';
import Head from '../../component/Page/Head';

const Terms = () => {
  return (
    <Fragment>
      <div className="overflow-hidden">
        <div className="bg__blue-2">
          <Navbar />
          <Head title="Términos de servicio" />
        </div>
        <img src="./../images/Subtract.png" className="w-100 img-cover" alt="" />

        <section>
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-md-10">
                <div className="wrapper__text-wrap">
                  <h1 className="semi-bold font__size--32 text__32-1024 text__32-md text__32-sm mb-3">📜 Términos de Servicio – ListoPago</h1>
                  <p className="normal font__size--16 text__16-1024 color__gray-1 lh-2 mb-2">
                    <strong>Última actualización:</strong> 1 de febrero de 2026
                  </p>
                  <p className="normal font__size--16 text__16-1024 color__gray-1 lh-2 mb-5">
                    <strong>Vigencia:</strong> Al usar ListoPago, aceptas estos términos.
                  </p>

                  <div className="mb-5">
                    <h2 className="semi-bold font__size--28 text__28-1024 text__28-md text__28-sm mb-3">1. Sobre el servicio</h2>
                    <p className="normal font__size--18 text__18-1024 color__gray-1 lh-2 mb-3">
                      ListoPago es una aplicación móvil que permite a dueños de negocios en Colombia:
                    </p>
                    <ul className="list-unstyled normal font__size--18 text__18-1024 color__gray-1 lh-2">
                      <li className="mb-2">Registrar ingresos y egresos mediante fotos de comprobantes bancarios.</li>
                      <li className="mb-2">Organizar transacciones por fecha, turno y banco.</li>
                      <li className="mb-2">Generar reportes básicos de gestión financiera.</li>
                    </ul>
                  </div>

                  <div className="mb-5">
                    <h2 className="semi-bold font__size--28 text__28-1024 text__28-md text__28-sm mb-3">2. Términos de Servicio – Descripción de planes</h2>
                    <p className="normal font__size--18 text__18-1024 color__gray-1 lh-2 mb-3">Planes disponibles (precios en COP, pago mensual o anual con ahorro de 2 meses):</p>
                    <ul className="list-unstyled normal font__size--18 text__18-1024 color__gray-1 lh-2 mb-4">
                      <li className="mb-3">
                        <strong>Básico ($29.900/mes):</strong>
                        <ul className="mt-2 pl-3">
                          <li className="mb-1">Hasta 5 fotos por carga.</li>
                          <li className="mb-1">Acceso a roles predefinidos: Admin, Contabilidad, Asesor 1, Asesor 2.</li>
                          <li className="mb-1">Sin exportación a PDF.</li>
                        </ul>
                      </li>
                      <li className="mb-3">
                        <strong>Plus ($39.900/mes):</strong>
                        <ul className="mt-2 pl-3">
                          <li className="mb-1">Hasta 10 fotos por carga.</li>
                          <li className="mb-1">Incluye módulo de Egresos.</li>
                          <li className="mb-1">Exportación a PDF de reportes.</li>
                          <li className="mb-1">Soporte por WhatsApp.</li>
                        </ul>
                      </li>
                      <li className="mb-3">
                        <strong>Premium ($59.900/mes):</strong>
                        <ul className="mt-2 pl-3">
                          <li className="mb-1">Rol adicional: Asesor 3.</li>
                          <li className="mb-1">Almacenamiento extendido de imágenes: 72 horas.</li>
                        </ul>
                      </li>
                    </ul>
                  </div>

                  <div className="mb-5">
                    <h2 className="semi-bold font__size--28 text__28-1024 text__28-md text__28-sm mb-3">3. Tu responsabilidad</h2>
                    <ul className="list-unstyled normal font__size--18 text__18-1024 color__gray-1 lh-2">
                      <li className="mb-2">Asegúrate de que las fotos de comprobantes sean legibles y reales.</li>
                      <li className="mb-2">No uses ListoPago para actividades ilegales o fraudulentas.</li>
                      <li className="mb-2">Eres responsable de la veracidad de la información que registras.</li>
                    </ul>
                  </div>

                  <div className="mb-5">
                    <h2 className="semi-bold font__size--28 text__28-1024 text__28-md text__28-sm mb-3">4. Precios y pagos</h2>
                    <p className="normal font__size--18 text__18-1024 color__gray-1 lh-2 mb-2">
                      <strong>Prueba gratuita:</strong> 15 días gratis de prueba (sin necesidad de tarjeta) en planes Plus y Premium.
                    </p>
                    <p className="normal font__size--18 text__18-1024 color__gray-1 lh-2 mb-2">
                      Los pagos se realizan voluntariamente mediante Nequi, Bancolombia u otro medio acordado. Puedes elegir facturación <strong>mensual</strong> o <strong>anual</strong> (con ahorro de 2 meses).
                    </p>
                    <p className="normal font__size--18 text__18-1024 color__gray-1 lh-2">
                      No hay suscripciones automáticas: Renovamos solo si tú decides pagar.
                    </p>
                  </div>

                  <div className="mb-5">
                    <h2 className="semi-bold font__size--28 text__28-1024 text__28-md text__28-sm mb-3">5. Propiedad intelectual</h2>
                    <ul className="list-unstyled normal font__size--18 text__18-1024 color__gray-1 lh-2">
                      <li className="mb-2">ListoPago y su código son propiedad de Brandon Stiven Zárate Vargas.</li>
                      <li className="mb-2">Queda prohibido copiar, modificar o distribuir la app sin autorización.</li>
                    </ul>
                  </div>

                  <div className="mb-5">
                    <h2 className="semi-bold font__size--28 text__28-1024 text__28-md text__28-sm mb-3">6. Limitación de responsabilidad</h2>
                    <ul className="list-unstyled normal font__size--18 text__18-1024 color__gray-1 lh-2">
                      <li className="mb-2">ListoPago no garantiza 100% de precisión en el OCR (revisa siempre los datos extraídos).</li>
                      <li className="mb-2">No somos responsables por pérdidas derivadas de errores en la interpretación de comprobantes.</li>
                      <li className="mb-2">El servicio se proporciona "tal cual", sin garantías expresas o implícitas.</li>
                    </ul>
                  </div>

                  <div className="mb-5">
                    <h2 className="semi-bold font__size--28 text__28-1024 text__28-md text__28-sm mb-3">7. Modificaciones y terminación</h2>
                    <ul className="list-unstyled normal font__size--18 text__18-1024 color__gray-1 lh-2">
                      <li className="mb-2">Podemos suspender el servicio temporalmente por mantenimiento.</li>
                      <li className="mb-2">Tú puedes eliminar tu cuenta en cualquier momento (se borrarán tus datos en 30 días).</li>
                      <li className="mb-2">Nos reservamos el derecho de modificar estos términos con 30 días de antelación.</li>
                    </ul>
                  </div>

                  <div className="mb-5">
                    <h2 className="semi-bold font__size--28 text__28-1024 text__28-md text__28-sm mb-3">8. Ley aplicable</h2>
                    <p className="normal font__size--18 text__18-1024 color__gray-1 lh-2 mb-0">
                      Estos términos se rigen por las leyes de la República de Colombia. Cualquier disputa se resolverá en los tribunales de Medellín, Antioquia.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <Footer />
      </div>
    </Fragment>
  );
};

export default Terms;
